import {graphql} from '~/graphql-react-query';

export const FollowedBrands = graphql(`
    query FollowedBrands($input: DashboardQueryV3Input!) {
        dashboardV3 {
            followedBrands(input: $input) {
                brands {
                    mediaValue {
                        previousPeriodTotal
                        currentPeriodTotal
                        change
                        hasAccess
                        currentPeriod {
                            month
                            spend
                        }
                        previousPeriod {
                            month
                            spend
                        }
                    }
                    creatives {
                        id
                        creative
                        firstAppeared
                        lastAppeared
                        status
                        adType {
                            id
                            name
                            canonicalName
                        }
                        categoryList {
                            id
                            name
                        }
                        mediaTypeList {
                            id
                            name
                            canonicalName
                        }
                        mediaOwnerList {
                            id
                            name
                        }
                        publicationList {
                            id
                            name
                        }
                        publisherList {
                            id
                            name
                        }
                        regionList {
                            id
                            name
                        }
                        productList {
                            id
                            name
                            brand {
                                id
                                name
                            }
                        }
                        brandList {
                            id
                            name
                        }
                        industryList {
                            id
                            name
                        }
                    }
                    brand {
                        name
                        id
                    }
                }
                paginationInfo {
                    currentPage
                    hasPreviousPage
                    hasNextPage
                }
            }
        }
    }
`);

export const TopBrands = graphql(`
    query TopBrands($input: DashboardQueryV3Input!) {
        dashboardV3 {
            topBrands(input: $input) {
                brands {
                    mediaValue {
                        previousPeriodTotal
                        currentPeriodTotal
                        change
                        hasAccess
                        currentPeriod {
                            month
                            spend
                        }
                        previousPeriod {
                            month
                            spend
                        }
                    }
                    creatives {
                        id
                        creative
                        firstAppeared
                        lastAppeared
                        status
                        adType {
                            id
                            name
                            canonicalName
                        }
                        categoryList {
                            id
                            name
                        }
                        mediaTypeList {
                            id
                            name
                            canonicalName
                        }
                        mediaOwnerList {
                            id
                            name
                        }
                        publicationList {
                            id
                            name
                        }
                        publisherList {
                            id
                            name
                        }
                        regionList {
                            id
                            name
                        }
                        productList {
                            id
                            name
                            brand {
                                id
                                name
                            }
                        }
                        brandList {
                            id
                            name
                        }
                        industryList {
                            id
                            name
                        }
                    }
                    brand {
                        name
                        id
                    }
                }
                paginationInfo {
                    currentPage
                    hasPreviousPage
                    hasNextPage
                }
            }
        }
    }
`);
